module.exports = __webpack_public_path__ + "static/media/ibm_logo.6fbcd789.png";